module.exports = __webpack_public_path__ + "Roboto-Light.3c37aa69cd77e6a53a06.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/roboto/Roboto-Light.woff2
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Light.woff2
// module chunks = styles